import CircularProgress from '@mui/material/CircularProgress';

const LoadingLocal: React.FC<{ size: string }> = ({ size }) => {
  return <CircularProgress color="inherit" size={+size} />;
};

export default LoadingLocal;
